import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TutorialModel } from '@app/core/models';
import { trackRequestResult } from '@ngneat/elf-requests';

import { TutorialsRepository } from '@app/store/tutorials.repository';
import { from, Observable, switchMap, tap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { environment } from 'src/environments/environment';
import { FirebaseAuthenticationService } from '../firebase';

/**
 * Service responsible for handling authentication-related functionality.
 */
@Injectable()
export class TutorialsService {
  constructor(
    private _router: Router,
    private _http: HttpClient,
    private _tutorialsRepo: TutorialsRepository,
    private authService: FirebaseAuthenticationService,
  ) {}

  /**
   * Retrieves the user roles from the server.
   * @returns An observable that emits the user roles.
   */
  getAll(propertyId: string): Observable<TutorialModel[]> {
    // Correctly await the token before making the request
    return from(this.authService.getIdToken({ forceRefresh: false })).pipe(
      switchMap(data => {
        // Use the Headers constructor correctly and include the token
        const headers = new Headers({
          Authorization: `Bearer ${data.token}`,
        });

        return fromFetch<TutorialModel[]>(
          `${environment.api.serverUrl}/properties/${propertyId}/tutorials`,
          {
            headers: headers,
            selector: response => response.json(),
          },
        );
      }),
      tap(tutorials => {
        this._tutorialsRepo.updateTutorials(tutorials);
      }),
      trackRequestResult(['tutorials'], { skipCache: true }),
    );
  }

  /*  editDate(
    serviceRequestId: string,
    date: {
      from: Date;
      to: Date;
    },
  ): Observable<TutorialModel> {
    return this._http
      .patch<TutorialModel>(
        `${environment.api.serverUrl}/tutorials/${propertyTutorialId}`,
        { date },
      )
      .pipe(
        tap(propertyTutorial => {
          this._tutorialsRepo.updateTutorials(propertyTutorial);
        }),
      );
  } */
}
